<template>
    <div class="auth__office-item auth__office-item--notice"
         @mouseover="hover = true"
         @mouseleave="hover = false"
    >
            <div class="auth__office-item--client" >
                <a :href="`/user/${user.id}/profile`" class="auth__office-link">
                    <img :src="user.avatar" :alt="user.name" v-if="user.avatar">
                    <span v-else v-text="getUserPM(user)"></span>
                </a>
            </div>
            <transition name="fade">
                <div class="notice notice--user" v-show="hover">
                    <div class="auth-user notice__item" v-if="user">
                        <div class="notice__item-header d-flex">
                            <a :href="`/user/${user.id}/profile`" class="notice__item-img">
                                <img :src="user.avatar" :alt="user.name" v-if="user.avatar">
                                <span v-else v-text="getUserPM(user)"></span>
                            </a>
                            <div class="notice__item-title">
                                <div class="auth-user__name" v-text="user.name"></div>

                                <!--  TODO Тип юзера  -->
                                <span v-if="user.organization" class="auth-user__subtitle">Организация:<br/><a :href="`/organizations/${user.organization.id}`">{{user.organization.name}}</a></span>
                                <span v-else-if="profileType === 'zooprotection'" class="auth-user__subtitle">Volunteer</span>
                                <span class="auth-user__subtitle" v-else>Donor</span>
                            </div>
                        </div>
                        <div class="notice__item-body" >
                            <div class="notice__item-office">
                                <ul class="auth-user__list">
                                    <li class="auth-user__item">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('profile-component')">
                                            <span class="auth-user__icon profile"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_profile')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('notification-component')">
                                            <span class="auth-user__icon notice"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_notifications')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('dashboard-component')">
                                            <span class="auth-user__icon dashboard"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_dashboard')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('settings-component')">
                                            <span class="auth-user__icon setting"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_profile_settings')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item" v-if="profileType === 'basic'">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('pets-component')">
                                            <span class="auth-user__icon notice"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_ads')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                        <a href="#" class="auth-user__link" @click.prevent="redirect('pets-component')">
                                            <span class="auth-user__icon less"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_my_wards')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                        <a :href="'/publication'" class="auth-user__link">
                                            <span class="auth-user__icon add"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_publish_card')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item" v-if="profileType === 'zooprotection'">
                                        <a :href="`/volunteer/${user.id}/finance-report`" class="auth-user__link">
                                            <span class="auth-user__icon transaction"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_transactions')}}</span>
                                        </a>
                                    </li>
                                    <li class="auth-user__item">
                                        <a href="/auth/logout" @click="resetState" class="auth-user__link">
                                            <span class="auth-user__icon exit"></span>
                                            <span class="auth-user__label">{{$store.getters.t('main_menu_logout')}}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
    </div>
</template>
<script>

import {mapMutations, mapGetters} from 'vuex'


export default {
    name: 'User',
    data(){
        return {
            appRoutes: null,
            hover: false,
        }
    },
    created() {
        this.appRoutes = window.appRoutes;
    },

    mounted() {
    },

    methods:{
        ...mapMutations({
            setComponent: 'setterProfileTab',
            resetState: 'resetDashboard'
        }),

        getUserPM(user){
            let nameArray = user.name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

        async redirect(component){

            if(window.location.href.indexOf(`/user/${this.user.id}/profile`) === -1){
                window.location.href = await ( window.location.origin + `/user/${this.user.id}/profile` )
            }

            await this.setComponent(component)

        },

    },

    computed:{
        user(){
            return this.$store.getters.getUserData
        },

        ...mapGetters({
            profileType: 'getUserProfileType',
        })


    }

}
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>
